import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Gradient from '@material-ui/icons/Gradient';
import React from 'react';
import SaudeCaixaApi from '../../api/SaudeCaixaApi';
import ParametroApi from '../../api/ParametroApi';
import { withLoading } from '../../contexts/LoadingContext';
import AlertDialogSlide from '../share/AlertDialogSlide';
import CalculoCoparticipacaoApi from '../../api/CalculoCoparticipacaoApi';

const styles = theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  button: {
    margin: theme.spacing(1),
  },
});

const PARAM_LANCAR_COPART_FOLHA_CAIXA = 34;

class ToolbarArquivoSelect extends React.Component {
  saudeCaixaApi = new SaudeCaixaApi();
  parametroApi = new ParametroApi();
  calculoCoparticipacaoApi = new CalculoCoparticipacaoApi();
  state = {
    openDialog: false,
  }

  handleClickCalcularCoparticipacao = () => {
    this.setState({ openDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleDialogConfirm = async () => {
    this.setState({ openDialog: false });
    this.props.handleClickToolBar();

    let registrosComErros = [];
    let registrosSemErros = [];
    let msgRetornoResumida = '';
    let registroComErro = {
      registro: '',
      mensagens: []
    };
    let result = {
      registrosComErros: [],
      registrosSemErros: [],
      msgRetornoResumida: ''
    };
    let retorno = {};
    this.props.showLoading('Recuperando dados dos procedimentos...');
    let procedimentos = await this.calculoCoparticipacaoApi.getProcedimentosCaixa();
    this.props.hideLoading();

    for (var i = 0; i < this.props.selectedRows.data.length; i++) {

      this.props.showLoading('Calculando Arquivo ' + this.props.displayData[this.props.selectedRows.data[i].index].data[0].props.children + ' (' + (i + 1).toString() + '/' + this.props.selectedRows.data.length.toString() + ')');
      retorno = await this.saudeCaixaApi.calcularCoparticipacao(Number(this.props.displayData[this.props.selectedRows.data[i].index].data[0].props.children), procedimentos);
      if (retorno !== undefined && retorno !== null) {
        if (retorno.data.codigoRetorno === 1) {
          registrosSemErros.push(retorno.data.registrosSemErros[0]);
          msgRetornoResumida = retorno.data.msgRetornoResumida;
          procedimentos = retorno.data.procedimentos;
        } else {
          registrosComErros.push(retorno.data.registrosComErros[0]);
        }
      } else {
        registroComErro.registro = this.props.displayData[this.props.selectedRows.data[i].index].data[0].props.children;
        let mensagem = ['Nao foi possivel realizar a operacao'];
        registrosComErros.mensagens.push(mensagem);
      }
      this.props.hideLoading();
    }
    await this.parametroApi.updateParametro(PARAM_LANCAR_COPART_FOLHA_CAIXA, 'S');
    result.registrosSemErros = registrosSemErros;
    result.msgRetornoResumida = msgRetornoResumida;
    result.registrosComErros = registrosComErros;
    this.props.setSelectedRows([]);
    this.props.onOperacaoFinalizada(result);
  };

  render () {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div className={classes.root}>
          <Button
            variant='contained'
            className={classes.button}
            onClick={this.handleClickCalcularCoparticipacao}
            color='primary'
            size='small'
            title='Calcular Coparticipação'>
            <Gradient className={classes.button} />
            Calcular Coparticipação...
          </Button>
        </div>
        <AlertDialogSlide
          open={this.state.openDialog}
          handleClose={this.handleCloseDialog}
          handleClick={this.handleDialogConfirm}
          title={'Calcular Coparticipação'}
          message={`A coparticipação de ${this.props.selectedRows.data.length}
                    arquivo(s) será(ão) calculada(s). Deseja prosseguir?`} />
      </React.Fragment>
    );
  }
}

export default withLoading(withStyles(styles)(ToolbarArquivoSelect));
